module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', _vm._b({
    class: [
      'select-component',
      'w-100',
      {
        'select-component-second': _vm.secondStyle
      } ],
    attrs: {
      "value": _vm.value,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.sendValue
    }
  }, 'el-select', _vm.$attrs, false), _vm._l((_vm.optionsComputed), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.itemText,
        "value": item.itemValue
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53485d92","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/selectComponent.vue
// module id = 461
// module chunks = 9 16 31 32 33